const supportMessages = [
  "Youth in Need",
  "LGBTQ+ Individuals",
  "Those Seeking Acceptance",
  "Displaced Community Members",
  "People of All Faiths",
  "Everyone Who Needs Support",
  "People of All Ages",
  "Those Seeking Help",
  "Community Members",
  "People in Crisis",
  "Those Seeking Connection",
  "People in Need",
  "Those Seeking Understanding",
  "People in Recovery",
  "Those Seeking Resources",
  "People in Transition",
  "Those Seeking Guidance",
  "People in Isolation",
  "Those Seeking Safety",
  "Those Seeking Hope",
  "Neurodivergent Youth",
  "First-Generation Students",
  "Young Artists & Creators",
  "Rural Youth",
  "International Students",
  "Gender-Questioning Individuals",
  "Differently Abled Youth",
  "Cultural Bridge-Builders",
  "Environmental Advocates",
  "Young Caregivers",
  "Alternative Learners",
  "Mental Health Champions",
  "Creative Spirits",
  "Identity Explorers",
  "Multicultural Families",
  "Peace Seekers",
  "Community Organizers",
  "Spiritual Seekers",
  "Knowledge Pursuers",
  "Future Leaders",
  "Wellness Advocates",
  "People who like pineapple on pizza",
  "Future Cat Ladies",
  "People who like to dance but it's banned in their town",
  "People who like to sing but are tone deaf",
  "People who like to write but can't spell",
  "Jeff",
  "The person who is reading this",
  "People who like to play the kazoo",
  "The butcher",
  "The baker",
  "The candlestick maker",
  "Frodo UnderHill",
  "People who stay on welcome pages for too long"
];

export default supportMessages;